"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var YouParticipate_1 = __importDefault(require("../YouParticipate"));
var ui_components_1 = require("@l2p/ui-components");
var ui_components_2 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var swr_hooks_2 = require("@l2p/swr-hooks");
var apps_shared_1 = require("@l2p/apps-shared");
var BlockWithTimer = function (_a) {
    var userConfirmed = _a.userConfirmed, id = _a.id, endAt = _a.endAt;
    var t = (0, next_intl_1.useTranslations)('translation');
    var _b = (0, swr_hooks_1.useJoinTournament)(), joinTournament = _b.joinTournament, isSubmitting = _b.isSubmitting;
    var isAuth = (0, swr_hooks_2.useIsAuthorized)();
    var signUpNavigate = (0, apps_shared_1.useOpenSignUp)();
    var participate = (0, react_1.useCallback)(function (id) {
        if (!isAuth)
            return signUpNavigate();
        if (id)
            joinTournament({ id: id });
    }, [joinTournament, signUpNavigate, isAuth]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.timerWrapper },
            react_1.default.createElement(ui_components_2.Timer, { endDate: endAt, title: t('tournamentWillFinish') })),
        !userConfirmed ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.participateContainer },
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", height: "50px", maxWidth: "100%", loading: isSubmitting, onClick: function () { return participate(id); } }, t('joinNow')))) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.alreadyParticipateContainer },
            react_1.default.createElement(YouParticipate_1.default, null)))));
};
exports.default = BlockWithTimer;
